/*
 * File: TeamsList.tsx
 * Project: a-a
 * File Created: Wednesday, 15th January 2025 8:45:27 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Friday, 18th July 2025 7:10:06 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
import { Box } from '@mui/material';
import React, { useEffect, useState } from 'react';

import { ClientService } from '../../../service/client.service';
import TeamColumnGrid from './TeamColumnGrid';
import TeamRowGrid from './TeamRowGrid';
type TeamData = {
  members: [
    {
      id: string | null;
      position: string | null;
      name: string | null;
      mobile: string | null;
      phone: string | null;
      address: {
        city: string | null;
        country: string | null;
        geocodeAccuracy: string | null;
        latitude: string | null;
        longitude: string | null;
        postalCode: string | null;
        state: string | null;
        street: string | null;
      };
      company: string | null;
      email: string | null;
      openDeals: string | null;
      openTasks: string | null;
      title: string | null;
      profile_image_url: string | null;
    },
  ];
};
type TeamListProps = {
  layout: 'column' | 'row';
  category: string;
  data: TeamData;
  loading: boolean;
};

const TeamsList = ({ layout, category, data, loading }: TeamListProps) => {
  return (
    <Box>
      {layout === 'column' ? (
        <TeamColumnGrid teams={data} category={category} loading={loading} />
      ) : (
        <TeamRowGrid teams={data} category={category} loading={loading} />
      )}
    </Box>
  );
};

export default TeamsList;
